import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiFollowUpBlock } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-response-follow-up',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './response-follow-up.component.html',
  styleUrl: './response-follow-up.component.css',
})
export class ResponseFollowUpComponent {
  @Input({ required: true }) block!: AiFollowUpBlock;
  @Output() followUpSelected = new EventEmitter<string>();
}
